import * as React from 'react';

import '../App.css'
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import bimLogo from '../images/bim_logo_100.png';
import Container from "@mui/material/Container";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: 400,
    bgcolor: 'background.paper',
    maxWidth: '600px',
    boxShadow: 24,
    p: 4,
    borderRadius: 2
};

function AppBarCustom({ mode, toggleColorMode }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  const [menu, setMenu] = useState({
      woman: {
          isOpened: true
      },
      men: {
          isOpened: false
      }
  })

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const scrollToSection = (sectionId) => {
    const sectionElement = document.getElementById(sectionId);
    const offset = 128;
    if (sectionElement) {
      const targetScroll = sectionElement.offsetTop - offset;
      sectionElement.scrollIntoView({ behavior: 'smooth' });
      window.scrollTo({
        top: targetScroll,
        behavior: 'smooth',
      });
      setOpen(false);
    }
  };


  return (
    <div className='AppBarCustom' sx={{ backgroundColor: 'black' }}>
      <AppBar
        // position="fixed"
        sx={{
          boxShadow: 0,
          // bgcolor: 'transparent',
          backgroundColor: "rgb(255 255 255/0.2)",
          backgroundImage: 'none'
          // mt: 2,
        }}
      >
          <Container
              sx={{
              }}
          >
              <Toolbar
                  variant="regular"
                  sx={(theme) => ({
                      paddingLeft: '0px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'start',
                      width: '100%',
                      flexShrink: 0,
                      // borderRadius: '999px',
                      // bgcolor: '#fff',
                      // theme.palette.mode === 'light'
                      //   ? 'rgba(255, 255, 255, 0.4)'
                      //   : 'rgba(0, 0, 0, 0.4)',
                      // backdropFilter: 'blur(24px)',
                      maxHeight: 40,
                      // border: '1px solid',
                      backgroundColor: 'transparent',
                      borderColor: 'divider',
                      // boxShadow:
                      //   theme.palette.mode === 'light'
                      //     ? `0 0 1px rgba(85, 166, 246, 0.1), 1px 1.5px 2px -1px rgba(85, 166, 246, 0.15), 4px 4px 12px -2.5px rgba(85, 166, 246, 0.15)`
                      //     : '0 0 1px rgba(2, 31, 59, 0.7), 1px 1.5px 2px -1px rgba(2, 31, 59, 0.65), 4px 4px 12px -2.5px rgba(2, 31, 59, 0.65)',
                  })}
              >
                  {/*<Box*/}
                  {/*    sx={{*/}
                  {/*        width: '100%',*/}
                  {/*        // display: { sm: ''}*/}
                  {/*        display: 'flex',*/}
                  {/*        alignItems: 'center',*/}
                  {/*        // position: 'relative',*/}
                  {/*        // justifyContent: 'flex-start',*/}
                  {/*        // '&::after': {*/}
                  {/*        //     content: '""',*/}
                  {/*        //     flex: 1*/}
                  {/*        // }*/}
                  {/*    }}>*/}
                  {/*</Box>*/}
                  <Box>
                      <Box
                          component='img'
                          onClick={() => { navigate('/')}}
                          alt="логотип bimclinics.ru"
                          sx={{
                              // flex: 1
                              height: {xs: '40px'},
                              width: {xs: '80px'},
                              cursor: 'pointer'
                          }}
                          src={bimLogo}
                      />
                  </Box>
              </Toolbar>
          </Container>
      </AppBar>
    </div>
  );
}


export default AppBarCustom;
